import { useState } from "react";

const EmailScreen = ({ showQuestionScreen }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  };

  const handleResponse = () => {
    if (email.includes("@")) {
      showQuestionScreen(email);
    } else {
      setError("Please enter a valid email address.");
    }
  };

  return (
    <div className="flex flex-col max-h-full w-full">
      <div className="flex font-sans font-medium text-gray-500 text-xs space-x-1 mb-2 px-8">
        <span>Interview</span>
        <span>·</span>
        <span>User Details</span>
      </div>
      <div className="font-sans font-semibold text-lg text-gray-900 mb-5 px-8">
        What is your email address?
      </div>
      <div className="px-8 w-full">
        <input
          type={email}
          required
          onChange={(e) => handleEmailInput(e)}
          placeholder="johndoe@gmail.com"
          className="h-12 w-full mt-2 border border-gray-200 rounded-xl font-sans px-4 font-medium text-gray-900 text-sm hover:border-blue-600 focus:outline-none focus:ring-4 focus:ring-blue-200 focus:border-blue-600"
        />
      </div>
      {error && (
        <div className="mt-4 mx-8 max-w-full h-10 rounded-xl bg-red-50 border border-red-100 flex space-x-2 justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-red-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="font-sans font-normal text-red-700 text-sm">
            Please enter a valid email address
          </span>
        </div>
      )}
      <div className="absolute bottom-0 w-full border-t border-gray-200 p-4">
        <button
          onClick={() => handleResponse()}
          className={` ${
            !email
              ? "bg-blue-200 pointer-events-none"
              : "bg-blue-600 hover:bg-blue-700"
          } w-full h-10 rounded-full  flex space-x-1 justify-center items-center `}
        >
          <span className="font-sans font-semibold text-white text-sm">
            Next
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EmailScreen;
